import { fetchBaseQuery, BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../Constans/URL';
import { setServerError } from './redux/globalSlice';  
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

const BASE_URL = API_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

const customBaseQuery: BaseQueryFn<
  Parameters<typeof baseQuery>[0],
  unknown,
  FetchBaseQueryError,
  {}
> = async (args, api, extraOptions) => {
  let retries = 3;

//   console.log("🚀 [API CALL] Request:", args);

  while (retries > 0) {
    try {
      const result = await baseQuery(args, api, extraOptions);

      if (result.error) {
        // console.error("❌ [API ERROR]:", result.error);
        
        if (result.error.status === 500 || result.error.status === "FETCH_ERROR") {
        //   console.log("⚠️ Server is down! Dispatching setServerError(true)");
          api.dispatch(setServerError(true));
        }
      }
       else {
        // console.log("✅ [API SUCCESS]:", result);
        api.dispatch(setServerError(false));
      }

      return result;
    } catch (error) {
    //   console.error("🌐 [NETWORK ERROR]:", error);
      retries--;

      if (retries === 0) {
        // console.log("🔥 Server unreachable after retries. Dispatching setServerError(true)");
        api.dispatch(setServerError(true));
      }

      await new Promise(res => setTimeout(res, 2000));
    }
  }

  return {
    error: {
      status: "FETCH_ERROR",
      error: "Server is unreachable",
    } as FetchBaseQueryError,
    data: undefined,
    meta: undefined,
  };
};

export default customBaseQuery;
